import React from 'react';
import * as S from './styled';
import './App.css';
import Information from './components/Information';



function App() {
  return (
    <S.Container>
      <Information/>
    </S.Container>
  );
}

export default App;
